module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/dc61fe2a47b27ec17c17d167c112e41c.png";